import React from 'react';
import { Box, Typography } from '@mui/material';
import { cardSx } from '../payment-analytics/StatsCardPayment';

// The Payment Analytics card look, for the Activity Logs popup: tinted icon, title, value, footer line.
const StatTile = ({ tone, Icon, title, value, footer }) => (
  <Box sx={cardSx(false)}>
    <Box display="flex" alignItems="center" gap={1}>
      <Box sx={{ width: 32, height: 32, flexShrink: 0, borderRadius: '8px', bgcolor: `${tone}14`, color: tone, display: 'grid', placeItems: 'center' }}>
        <Icon sx={{ fontSize: 18 }} />
      </Box>
      <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#3C4043' }} noWrap>{title}</Typography>
    </Box>
    <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#111', lineHeight: 1.2, wordBreak: 'break-word' }}>{value}</Typography>
    {footer != null && (
      <Box sx={{ fontSize: 12, color: '#5F6368', borderTop: '1px dashed #ECECEC', pt: 1.25, mt: 'auto' }}>{footer}</Box>
    )}
  </Box>
);

export default StatTile;
